export default "__VITE_ASSET__iu$dpoO$__"